import React from 'react';
import { useFormContext } from 'react-hook-form';
import RadioButton from '@/app/components/buttons/RadioButton';
import { TextArea } from '@/app/components/form/TextArea';
import { SEAT_PREFERENCES, type CreateClientFormData } from '@/types/clientsApiTypes';
import type { RelatedPassengerBasePath } from '@/types/clientsApiTypes';

type RelatedPassengerTravelPreferencesAllergiesProps = {
  basePath: RelatedPassengerBasePath;
  onUpdateFormData?: (fieldName: string, fieldValue: unknown) => void;
};

export const RelatedPassengerTravelPreferencesAllergies = ({
  basePath,
  onUpdateFormData,
}: RelatedPassengerTravelPreferencesAllergiesProps) => {
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext<CreateClientFormData>();

  const handleSaveOnBlur = (name: string, value: unknown) => {
    onUpdateFormData?.(name, value);
  };

  const seatPreference = watch(`${basePath}.preference_data.fly.seat`);

  return (
    <div className="grid grid-cols-1">
      <p className="text-body-small text-blue-900 mt-3 mb-2">Seat Preference</p>

      <div className="flex items-center gap-6 mb-4">
        <RadioButton
          label="Window"
          name={`${basePath}.preference_data.fly.seat`}
          checked={seatPreference === SEAT_PREFERENCES.window}
          onChange={() => setValue(`${basePath}.preference_data.fly.seat`, SEAT_PREFERENCES.window)}
          onBlur={(e) => handleSaveOnBlur(e.target.name, SEAT_PREFERENCES.window)}
        />
        <RadioButton
          label="Aisle"
          name={`${basePath}.preference_data.fly.seat`}
          checked={seatPreference === SEAT_PREFERENCES.aisle}
          onChange={() => setValue(`${basePath}.preference_data.fly.seat`, SEAT_PREFERENCES.aisle)}
          onBlur={(e) => handleSaveOnBlur(e.target.name, SEAT_PREFERENCES.aisle)}
        />
      </div>

      <TextArea
        {...register(`${basePath}.preference_data.allergies`)}
        disableResize
        label="Allergies & dietary restrictions"
        placeholder="e.g. nut allergy, gluten-free, lactose intolerance"
        rows={4}
        errors={errors}
        onBlur={(e) => handleSaveOnBlur(e.target.name, e.target.value)}
      />
    </div>
  );
};
